































































import { Component, Vue, Prop } from "vue-property-decorator";
import { DeleteQuestion$ } from "@/request/jxgl";
@Component({})
export default class XtkQuestionList extends Vue {
  @Prop()
  private questions;
  @Prop()
  private filters;
  private selectChange(value, row) {
    this.$emit("selectChange", value, row);
  }
  /**
   * @description 编辑
   */
  private compose(row) {
    this.$router.push({
      path: "/main/jxgl/xtk-detail",
      query: {
        id: row["question_id"],
      },
    });
  }
  /**
   * @description 查看
   */
  private check(row) {
    this.$router.push({
      path: "/main/jxgl/xtk-detail",
      query: {
        id: row["question_id"],
      },
    });
  }
  /**
   * @description 删除
   */
  private deleteThis(row) {
    this.$confirm("删除后将无法找回，您确定要删除么？", {
      title: "温馨提示",
    })
      .then((value) => {
        const params: any = {
          data: {
            question_id: row["question_id"],
          },
        };
        DeleteQuestion$(this, params).then((data: any) => {
          this.$message.success("删除成功");
          this.$emit("deleteDone");
        });
      })
      .catch((err: any) => {
        console.log(err);
      });
  }
}
